<template>
  <div class="page-wrapper">
    <v-container>
      <v-row>
        <v-col class="text-left">
          <p>
          귀국 이사, 삼국간 이사, 영국내 이사 페이지입니다.
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" style="padding-left:5px;padding-right: 5px;">
          <v-card @click="changeMode(100)" >
            <div class="card-img-wrapper">
              <div class="ko-move-image"></div>
              <div class="ko-move-image"></div>
<!--              <img class="card-img" src="/static/img/korea2.png">-->
            </div>

            <div class="card-body" :class="{'activated': mode >=100 && mode <= 199}" style="padding-right: 3px;padding-left: 3px;" >
              <h6 class="text-center">귀국 이사</h6>
            </div>
          </v-card>
        </v-col>

        <v-col cols="4" style="padding-left:5px;padding-right: 5px;">
          <v-card @click="changeMode(200)" >
            <div class="card-img-top">
              <img class="card-img" src="/static/img/world.png">
            </div>
            <div class="card-body" :class="{'activated': mode >=200 && mode <= 299}" style="padding-right: 3px;padding-left: 3px;" >
              <h6 class="text-center">삼국간 이사</h6>
            </div>
          </v-card>
        </v-col>

        <v-col cols="4" style="padding-left:5px;padding-right: 5px;">
          <v-card @click="changeMode(300)" >
            <div class="card-img-top">
              <img class="card-img" src="/static/img/uk.png">
            </div>
            <div class="card-body" :class="{'activated': mode >=300 && mode <= 399}" style="padding-right: 3px;padding-left: 3px;" >
              <h6 class="text-center">영국내 이사</h6>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row style="display: none;">
        <v-col cols="12">
          <template v-for="(p, index) in processList">
            <span>{{p.title}}</span>
            <span v-if="index < processList.length-1"><i class="fas fa-arrow-right"></i></span>
          </template>

        </v-col>
      </v-row>

    </v-container>
    <transition-group name="list">
      <v-container v-if="mode >=100 && mode <= 199" :key="'section-100'">
        <v-row>
          <v-col class="col-12 col-md-6">
            <v-card class="card pa-5 fill-height text-left" outlined>
  <!--            <div class="card-body">-->
                <h5>상사 주재원(기관)</h5>
                <p>
                  영국에서 한국으로 귀국 이삿짐을 보내는 경우 상사(기관) 주재원은 회사에서 지원하는 용적의 기준이 있으며 사전 SURVEY를 통하여 용적에 적합한지 알아보시고 포장-보험가입-선적-도착지 통관-자택 배송까지 전반적인 안내를 받으시기 바랍니다.
                </p>
  <!--            </div>-->
            </v-card>
          </v-col>
          <v-col class="col-12 col-md-6">
            <v-card class="card pa-5 fill-height text-left" outlined>
  <!--            <div class="card-body">-->
                <h5>단기 연수, 유학생(소량 화물)</h5>
                <p>
                  소량화물의 경우는 컨테이너를 SHARE 하는 운송 방법이 가장 저렴하고 안전하지만 FCL(단독으로 CNTR 이용)보다 보통 1-2주 운송 기간이 더 소요 됩니다. 그러나 사전 예약을 할 경우 운송을 최대한 단축 할 수 있습니다.
                </p>
  <!--            </div>-->
            </v-card>
          </v-col>
        </v-row>

      </v-container>
      <v-container class="text-left" v-if="mode >= 200 && mode <= 299"  :key="'section-200'">
        <v-row>
          <v-col cols="12">
            삼국간 이사
          </v-col>
          <v-col cols="12">
            <p>
              영국에서 프랑스, 네덜란드, 독일, 이태리 등 해협을 건너 가까운 유럽으로 이사를 할 경우 보통 트럭으로 운송을 하게 됩니다. 프랑스 파리의 경우는 포장 후 2일-3일 네덜란드나 독일의 경우는 3일-4일 후 현지 배송이 가능합니다. 목적국에 입주 할
              그 외 가까운 유럽을 제외한 3국간의 이사는 귀국이사와 마찬가지로 해상 컨테이너를 이용하고 목적국마다 항해 일수가 다르므로 필요한 정보는 운송회사의 담당자와 상담을 하시기 바랍니다.
            </p>
          </v-col>
        </v-row>
      </v-container>

      <v-container class="text-left" v-if="mode >= 300 && mode <= 399" :key="'section-300'">
        <v-row>
          <v-col cols="12">
            영국내 이사
          </v-col>
          <v-col cols="12">
            <p>
              영국내 포장이사의 경우 짐의 양이 많고 이사를 겨울철에 해야 하는 경우는 하루 전 포장 다음 날 운반 및 정리 정돈을 해야 하는 경우도 있습니다. 그러나 보통의 경우는 아침 일찍 시작을 하면 하루에 모두 완료가 가능 합니다.
            </p>
            <p>포장 이사 와 일반 이사의 비용 차이가 있으니 방문시 상담 하시기 바랍니다.</p>
          </v-col>
        </v-row>
      </v-container>
    </transition-group>

    <div class="container text-left border-top">
      <div class="row">
        <div class="col-12 section-header">
          방문 신청
        </div>
        <div class="col-12">
          <p><span style="color:#FF5733;">런던 근교의 경우 방문 날짜는 일주일전 신청 바랍니다. 지방의 경우는 전화로 사전 문의 바랍니다.</span><br><a href="tel:07837203341">+44 7837 203 341</a></p>
          <template v-if="mode < 300">
          <p>신청전에 아래의 사항을 확인해주세요</p>
          <ul class="clickable">
            <li><span class="border-btn" v-on:click="openTnc('checkList')">사전 안내 및 점검사항 <i class="fas fa-chevron-right"></i></span></li>

            <li><span class="border-btn" v-on:click="openTnc('insurance')">보험 안내 <i class="fas fa-chevron-right"></i></span></li>
            <li v-if="mode < 200"><span class="border-btn" v-on:click="openTnc('freight')">국제운송 약관 <i class="fas fa-chevron-right"></i></span></li>
          </ul>
<!--          <pdf-loader button-name="사전 안내 및 점검사항" path="/static/doc/move_checklist.pdf"></pdf-loader>-->
<!--          <pdf-loader button-name="보험 안내" path="/static/doc/uko-insurance.pdf"></pdf-loader>-->

<!--          <pdf-loader button-name="국제운송 약관" path="/static/doc/terms.pdf"></pdf-loader>-->
          </template>
        </div>
        <div class="col-12" v-show="visitFormItem == false">
          <v-btn class="primary" v-on:click="newVisitForm">방문 견적 온라인 요청하기</v-btn>
          <br><br>
          <a href="/static/doc/survey_form.xlsx" download style="display: none;"><v-btn class="primary">방문 견적 요청서 다운로드</v-btn></a>
        </div>
      </div>

      <div v-if="visitFormItem != false">
        <VisitRequestForm
          :item="visitFormItem"
          :on-close="closeVisitForm">
        </VisitRequestForm>
      </div>
    </div>


    <template v-if="mode >= 100 && mode <200">
      <div class="container text-left">
        <div class="row">
          <div class="col-12 section-header">
            견적 내기
          </div>
          <div class="col-12">
            <p>자택 방문 후 화물의 용적 산출 및 이사 비용 견적을 내어 드립니다.</p>
          </div>
        </div>
      </div>

      <div class="container text-left">
        <div class="row">
          <div class="col-12 section-header">
            포장 및 물류창고 입고
          </div>
          <div class="col-12">
            포장된 이삿짐은 당사 물류 창고로 입고(단독 컨테이너의 경우 거주지 진입이 가능한 경우 직접 컨테이너에 로딩)후 출항 시점에 맟추어 출고 가 됩니다.
          </div>
        </div>
      </div>

      <div class="container text-left">
        <div class="row">
          <div class="col-12 section-header">
            선적
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <p>고객님의 귀국 이사 화물이 적재된 컨테이너의 선적이 완료된 후 선적 증빙 서류가 발급되며,담당 컨설턴트가 화물 선적일정과 세부 내용,각종 ,필요 서류,UKO  Shipping 본사 연락처 및 담당자 정보가 담긴 운송 안내 메일을 발송해 드립니다.</p>
          </div>
        </div>
      </div>


      <div class="container text-left">
        <div class="row">
          <div class="col-12 section-header">
            입항 안내
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p>부산 항 또는 인천 항 입항 일주일 전에 고객님께 안내 연락을 드릴 것입니다. (통관 준비 서류 및 예상 배송 일짜 안내)</p>
          </div>
        </div>
      </div>

      <div class="container text-left">
        <div class="row">
          <div class="col-12 section-header">
            도착지 통관
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p>입항 안내 시점에 안내 받은신 통관 서류를 서울 지사로 이 메일 스캔으로 보내주시면 통관은 평일 오전에 진행 되며 통관 심사를 마치고 자택으로 배송 됩니다. 자택 배송 일정 및 시간은 서울 지사와 상당 및 조절 하시기 바랍니다. 일반적으로 입항일 기준 자택 배송일 까지 5-7일이 소요 됩니다.</p>
          </div>
          <div class="col-12">
            자세한 내용은 아래의 관세청 사이트에서 확인해주세요<br>
            <v-btn ><a href="https://www.customs.go.kr/download/_down/e-leaflet_201810.pdf" target="_blank">해외 이사물품 통관안내</a></v-btn>
            <br><br>
            <v-btn ><a href="https://www.customs.go.kr/kcs/ad/cntnts/cntntsView.do?cntntsId=8454&mi=8454" target="_blank">이사화물 통관절차 관세청 사이트</a></v-btn>


          </div>
        </div>
      </div>

      <div class="container text-left">
        <div class="row">
          <div class="col-12 section-header">
            자택 배송
          </div>
          <div class="col-12">
            <p>배송일자 가 확정 되면 사전에 사다리차 또는 승강기 예약을 위하여 현지 배송 담당자가 최종 확인을 해 드릴것입니다. 배송 당일에는 큰 가전제품이나 가구등 대형 화물은 해체 조립등을 마친후 자리 배치해 드리며 , 해체한 폐기 박스들은 회수 하여 드립니다.</p>
            <p style="color:#FF5733;">작은박스 (의료 ,주방용품 ,책등)의 unpaking 정리 풀 셋팅 서비스를 희망하시는 경우 한국 지사 담당에게 문의 및 신청 바랍니다. (계약 조건에 따라 추가 비용이 발생 할수 있습니다.) 손상 또는 분실된 화물이 발생할 경우 배송일로 부터 14일 이내에 도착지 담당자에게 이메일 또는 유선상으로 Claim 접수 해주시기 바랍니다.</p>
          </div>
        </div>
      </div>
    </template>

    <div v-if="visitFormItem == false" style="position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); padding: 10px 30px 10px 30px; background-color: #1976d2; color:white; font-weight: bold; border-radius: 10px; box-shadow: 3px 3px 5px grey; cursor: pointer;" v-on:click="newVisitForm">이사 견적/문의 요청하기</div>
  </div>
</template>

<script>
  require('@/assets/css/style.css')
  import EventBus from "../api/event-bus";
  import VisitRequestForm from "../form/VisitRequestForm";
  import PdfLoader from "./PdfLoader";
  import {getProcessList} from "../api/utils";
  import axios from 'axios';

  export default {
        name: "Move",
        components: {
          PdfLoader,
          VisitRequestForm
        },
        data() {
          return {
            mode: 100,
            visitFormItem:false,
            processList:[],
          }
        },
        created() {
          this.getProcess();
          EventBus.$on('onSubmitted', this.onRequestSubmitted);
        },
        mounted() {
        },
        methods: {
          getProcess: function() {
            let self = this;
            self.$data.processList = getProcessList()
          },
          changeMode: function(newMode) {
            this.$data.mode = 0;
            let self = this;
            setTimeout(function() {self.changeModePost(newMode)}, 500)
          },
          changeModePost: function(newMode) {
            this.$data.mode = newMode;
            if(this.$data.visitFormItem != false) {
              if(this.$data.mode >= 100) {
                this.$data.visitFormItem.requestType = 'korea';
                this.$data.visitFormItem.countryTo = '대한민국';
              }
              if(this.$data.mode >= 200) {
                this.$data.visitFormItem.requestType = 'world';
                this.$data.visitFormItem.countryTo = '영국';
              }
              if(this.$data.mode >= 300) {
                this.$data.visitFormItem.requestType = 'uk';
                this.$data.visitFormItem.countryTo = '영국';
              }
            }
          },
          closeVisitForm: function() {
            this.$data.visitFormItem = false;
          },
          newVisitForm: function() {
            this.$data.visitFormItem = {
              id:0,
              requestType:'',
              visitDate:'',
              visitHour:10,
              shippingMode:"",
              requester:"",
              headCount:0,
              phoneNumber:'',
              email:'',
              companyName:'',
              countryFrom:'UK',
              addressFrom:'',
              countryTo:'',
              addressTo:'',
              expectedMoveDate:'',
              state:0,


            }
            if(this.$data.mode >= 100) {
              this.$data.visitFormItem.requestType = 'korea';
              this.$data.visitFormItem.countryTo = '대한민국';
            }
            if(this.$data.mode >= 200) {
              this.$data.visitFormItem.requestType = 'world';
              this.$data.visitFormItem.countryTo = '영국';
            }
            if(this.$data.mode >= 300) {
              this.$data.visitFormItem.requestType = 'uk';
              this.$data.visitFormItem.countryTo = '영국';
            }
          },
          openTnc: function(tnc) {
            EventBus.$emit("tnc", tnc);
          },
          submitRequest: function() {
            console.log("Request to submit");
            console.log(this.$data.visitFormItm);
          },
          onRequestSubmitted: function() {
            // window.alert("감사합니다. 이메일을 확인해주세요");
            this.$data.visitFormItem = false;
          }
        }
    }
</script>

<style scoped>
  .activated {
    background: #74C77D;
    color:white;
  }
  .section-container {
    margin-top:30px;
    /*border: solid 1px black;*/
    padding-top:30px;
  }
  .row-section {
    margin-top: 30px;
  }
  .card-img-top {
    background: #ccc;
    text-align: center;
    padding-top:20px;
    padding-bottom: 20px;
  }
  .card-img {
    width: 80%;
    max-width: 150px;
  }
  .card-img-wrapper {
    width: 100%;
    height: 190px;
    min-height: 190px;
    /*display: inline-block;*/
    /*max-height: 300px;*/


  }
  .ko-move-image:nth-child(1) {
    width: 50%;
    height: 100%;
    float:left;
    background-image: url('../assets/img/port.jpg');
    background-size: cover;
    background-position: center;
  }
  .ko-move-image:nth-child(2) {
    width: 50%;
    height: 100%;
    float:left;
    background-image: url('../assets/img/aircargo.jpg');
    background-size: cover;
    background-position: center;
  }

  @media only screen and (max-width: 420px) {
    .card-body > h2 {
      font-size: small;
    }
    .card-body {
      padding: 0.5rem;
    }
    .card-img-top, .card-img-wrapper {
      height: 125px;
      min-height: 125px;
      max-height: 125px;
    }
    .ko-move-image:nth-child(1) {
      width: 100%;
      height: 50%;
      float:left;
      background-image: url('../assets/img/port.jpg');
      background-size: cover;
      background-position: center;
    }
    .ko-move-image:nth-child(2) {
      width: 100%;
      height: 50%;
      float:left;
      background-image: url('../assets/img/aircargo.jpg');
      background-size: cover;
      background-position: center;
    }
  }
  .list-enter-active, .list-leave-active {
    transition: all 0.5s;

  }
  .list-enter{
    opacity: 0;
    transform: rotateY(90deg);
  }
  .list-leave-to {
    opacity: 0;
    transform: rotateY(90deg);
  }
  .list-group-item.selected {
    background: blue;
    color:white;

  }

  .section-header {
    background: #f1f1f1;
    font-size: 1.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Move.vue